export default __webpack_public_path__ + "static/media/cc-agent-2.1658e980.webp";